module.exports = __webpack_public_path__ + "static/media/video-screenshot.71450b43.png";